import { hideSections, showSections, disableFieldsForSections, enableFieldsForSections } from "./helpers";

const INDEX_CONTAINER_CLASSNAME = '.training-tasks'
const FORM_CONTAINER_ID = "#training_task_form_fields"
const task_type_names = ['watch', 'question', 'review'];

$(document).on('turbolinks:load', function() {
  $(".bulk-task").attr("disabled", true);

  $('body').on('click', '#training_task_form_fields .add-button', function(e) {
    e.preventDefault();
    addNewOptionField();
  });

  $('#training-task-form').on('keypress', e => {
    if (e.keyCode == 13) {
        return false;
    }
  });

  const table_row_checkbox = INDEX_CONTAINER_CLASSNAME + ' .row-checkbox';

  $('body').on('click', table_row_checkbox, function() {
    if ($(table_row_checkbox + ":checked").length > 0){
      $(".bulk-task").attr("disabled", false);
    } else {
      $(".bulk-task").attr("disabled", true);
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .type-filter').change(function(){
    var type = $(this).val()
    let url = new URL(window.location.href);

    if(type == "all"){
      url.searchParams.delete("type")
    } else {
      url.searchParams.set("type", type)
    }

    window.location.href = url.href;
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .view-filter').change(function(){
    var type = $(this).val()
    let url = new URL(window.location.href);

    if(type == "default"){
      url.searchParams.delete("view")
    } else {
      url.searchParams.set("view", type)
    }

    window.location.href = url.href;
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-delete').click(function() {
    var task_ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      task_ids.push(obj.id)
    })

    if (confirm('Delete all selected tasks?')){
      $.ajax({
        url: "/training_tasks/bulk_delete",
        method: "DELETE",
        data: { task_ids: task_ids },
        success: (response) => {
          location.reload();
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-clone').click(function() {
    var task_ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      task_ids.push(obj.id)
    })

    if (confirm('Clone all selected tasks?')){
      $.ajax({
        url: "/training_tasks/bulk_clone",
        method: "POST",
        data: { task_ids: task_ids},
        success: (response) => {
          setTimeout(function(){ location.reload() }, 1000);
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }
  });

  $('#templateSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('template', val)

    } else {
      url.searchParams.delete('template')
    }

    window.location.href = url.href;
  });

  $('#post-select').select2({
    ajax: {
      url: '/posts_search.json',
      dataType: 'json',
    },
    templateResult: function (res) {
      console.log(res)
      var $container = null
      $container = $("<div>" + res.text + "</div>");

      return $container;
    }
  });

  $(FORM_CONTAINER_ID + ' .type-radio').change(function(){
    var type = $(this).val()

    if (type){
      showSections([type]);
      var other_types = [...task_type_names]

      const index = other_types.indexOf(type);
      if (index > -1) {
        other_types.splice(index, 1);
      }

      enableFieldsForSections([type])
      hideSections(other_types)
      disableFieldsForSections(other_types)
    } else {
      hideSections(task_type_names)
      disableFieldsForSections(task_type_names)
    }
    
  })
  
  $(FORM_CONTAINER_ID + ' .question_type').change(function () {
    var type = this.value;

    var input_type = getCheckboxType(type);

    $(FORM_CONTAINER_ID + ' .admin-input').each(function(){
      this.type = input_type
    });

    if (type == "text_entry"){
      hideSections(["task_options"])
      disableFieldsForSections(["task_options"])
    } else {
      showSections([["task_options"]]);
      enableFieldsForSections([["task_options"]]);
    }

  });

  $(FORM_CONTAINER_ID + ' #video-field').on('change', function () {
    var file = this.files[0];

    $(FORM_CONTAINER_ID + ' #video-btn').html(file.name)
  });

  $(FORM_CONTAINER_ID + ' #thumb-field').on('change', function () {
    var file = this.files[0];

    $(FORM_CONTAINER_ID + ' #thumb-btn').html(file.name)
  });

  $('body').on('keydown', FORM_CONTAINER_ID + ' #task_options_field .option-field input[type="text"]', function(e) {
    if (e.keyCode == 13) { 
      addNewOptionField();
    } 
  });

  $('body').on('click', FORM_CONTAINER_ID + ' #task_options_field .admin-input', function(e) {
    this.value = $(this).parent().siblings('.option-field').find('input').val()
  });

  $(INDEX_CONTAINER_CLASSNAME + ' #tag_select').change(function(){
    let url = new URL(window.location.href);
    var val = $(this).val()

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('task_tags', val.join(","))
    } else {
      url.searchParams.delete('task_tags')
    }

    window.location.href = url.href;
  });

  $(FORM_CONTAINER_ID + " .add-scale-btn").click(function(){
    Array.from({length: 7}, (v, k) => k+1).forEach(function(value){
      addNewOptionField(value);
    })

    $(this).hide();
  });

  initializeDivs();
});

function initializeDivs(){
  hideSections(task_type_names);
  disableFieldsForSections(task_type_names)

  var type_selected = $(FORM_CONTAINER_ID + ' .type-radio:checked').val();
  var question_selected = $(FORM_CONTAINER_ID + ' .question_type:checked').val();

  if (type_selected){
    showSections([type_selected]);
    enableFieldsForSections([type_selected]);
  }

  if (question_selected == "text_entry" || question_selected == undefined){
    hideSections(["task_options"])
    disableFieldsForSections(["task_options"])
  }
}

function addNewOptionField(field_value = ""){
  var input_div = "<input class='form-control' name='training_task[response_options][]' placeholder='Option' type='text' value='"+field_value+"'>"
  var add_btn = "<button class='btn btn-outline-success add-button' type='button'><i class='fa fa-plus' aria-hidden='true'></i></button>"
  var delete_icon = "<i class='fa fa-times' aria-hidden='true'></i>"

  var question_type = $(FORM_CONTAINER_ID + ' .question_type:checked').val();
  var star_icon = "<input type='"+getCheckboxType(question_type)+"' class='admin-input glyphicon glyphicon-star-empty' name='training_task[correct_response][]'>"

  const reponse_options_section = "#training_task_form_fields #task_options_field "

  $('.add-button').empty().removeClass("btn-outline-success add-button").addClass("btn-outline-danger remove-button").append(delete_icon)

  var last_row_selector = ".row:last-child"
  $("#training_task_form_fields #task_options_field.admin-view " + last_row_selector + ' .star-icon').append(star_icon)

  $(reponse_options_section).append("<div class='row mt-1'></div>")
  $(reponse_options_section + last_row_selector).append("<div class='col-md-3'><div>")
  $(reponse_options_section + last_row_selector).append("<div class='col-md-5 option-field'><div>")
  $(reponse_options_section + last_row_selector + " .option-field").append(input_div)
  $(reponse_options_section + last_row_selector).append("<div class='col-md-1 button'><div>")
  $(reponse_options_section + last_row_selector + " .button").append(add_btn)
  $(reponse_options_section + last_row_selector).append("<div class='col-md-1 star-icon'><div>")

  $(reponse_options_section + last_row_selector + " .option-field input").focus();
}

function getCheckboxType(type) {
  if (type == "checkboxes")
    return "checkbox"
  
  if (type == "radios")
    return"radio" 
}